export default {
  labels: {
    today: 'Vandaag',
    pickup_time: 'Afhaaltijd',
    on_site_time: 'Serveertijd',
    delivery_time: 'Bezorgtijd',
  },
};
